const template = /* xml */ `<db:button>
	<button data-id='button'>
		<span data-id='text'>something</span>
	</button>
</db:button>`;

const Button = DomClass(template, function() {
	this.handleClick = () => {
		if (typeof this.onclick === 'function') {
			this.onclick();
		}
	};

	this.button.onkeyup = e => {
		e.stopPropagation();
		if (e.key === 'Enter' || e.key === ' ') this.handleClick();
	};

	this.button.onclick = e => {
		e.stopPropagation();
		this.handleClick();
	};

});

export default Button;